import {callApi} from '@/lib/api/callApi';

/**
 * 取得比賽/活動/檢定列表與搜尋列表
 * @param {Object} params 傳入的參數物件
 * @param {Number} params.offset 從多少數量之後開始回傳
 * @param {Number} params.limit 回傳多少數量
 * @param {[Number]} [params.cityId] 地級行政區代碼
 * @param {[Number]} [params.type] 縣級行政區代碼
 * @param {[TournamentStatus]} [params.status] 比賽狀態
 * @param {[Number]} [params.hostBy] 建立的機構
 * @param {String} [params.name] 搜尋的關鍵字
 * @returns {Promise} promise
 */
async function getEvents(params) {
  const res = await callApi({
    category: 'events',
    apiName: '',
    method: 'get',
    params,
    defaultError: null,
  });
  return res.data;
}

/**
 * 取得比賽/活動/檢定
 * @param {String} eventId eventId
 * @returns {Promise} promise
 */
async function getEventById(eventId) {
  const res = await callApi({
    category: 'events',
    apiName: eventId,
    method: 'get',
    defaultError: null,
  });
  return res.data;
}

/**
 * 取得活動地址列表
 * @param {String} eventId eventId
 * @returns {Promise} promise
 */
async function getAddress(eventId) {
  const res = await callApi({
    category: 'events',
    apiName: `${eventId}/addresses`,
    method: 'get',
  });
  return res.data;
}

/**
 * 報名比賽
 * @param {String} path.id event id
 * @param {String} path.groupId 組別id
 * @param {Object} data post的資料
 * @returns {Promise} promise
 */
async function registration({id, groupId}, data) {
  const res = await callApi({
    category: 'events',
    apiName: `${id}/groups/${groupId}/registration`,
    method: 'post',
    data,
  });
  return res.data;
}

/**
 * 取得該組別的所有子組別
 * @param {Number} params 組別
 * @param {Number} params.eventGroupId 組別 id
 * @returns {Promise} promise
 */
async function getEventSubGroups(params) {
  const res = await callApi({
    category: 'events',
    apiName: 'sub-groups',
    method: 'get',
    params,
  });
  return res.data;
}

/**
 * 取得該組別成績清單
 * @param {String} eventSubGroupId event id
 * @returns {Promise} promise
 */
async function getSubGroupPlayers(eventSubGroupId) {
  const res = await callApi({
    category: 'events',
    apiName: `sub-groups/${eventSubGroupId}/players`,
    method: 'get',
  });
  return res.data;
}

/**
 * 取得該組別成績清單
 * @param {String} eventId event id
 * @param {String} name 搜尋的姓名
 * @param {String} agencyName 搜尋的機構
 * @returns {Promise} promise
 */
async function searchSubGroupPlayers({eventId, name, agencyName}) {
  const params = {
    eventId,
    name,
    agencyName,
  };
  const res = await callApi({
    category: 'events',
    apiName: 'sub-group-players',
    method: 'get',
    params,
  });
  return res.data;
}

export default {
  getEvents,
  getAddress,
  getEventById,
  registration,
  getSubGroupPlayers,
  getEventSubGroups,
  searchSubGroupPlayers,
};
